<div class="box">
    <div class="content" fxFlex="100">
        <div class="header" fxFlex="100">
            <span>{{headingLabel ? headingLabel : 'Update Request Status'}}</span>
            <span class="desc">
                {{description ? description : 'Provide your remarks for updating the request status.'}}
            </span>
        </div>

        <div class="input" fxFlex="100">
            <div class="field">
                <span>Remarks *</span>
                <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="statusChangeObject.remarks"
                    [name]="'request'" [errors]="errorObj.remarks">
                </app-text-field>
            </div>
        </div>
    </div>
    <div class="btnSet" fxFlex="100">
        <button *ngIf="showCancel" mat-raised-button class="Cancel" (click)="cancelRequest()">
            Cancel
        </button>
        <button mat-raised-button class="Cancel" (click)="defaultRequest()">
            {{buttonLabel ? buttonLabel : 'Update Status'}}
        </button>
    </div>
</div>